import { takeEvery, put, takeLatest, delay, select } from 'redux-saga/effects';
import Querystring from 'querystring';
import types from 'redux/types';
import hooks from 'hooks';
import Services, { HeaderUTF8Option } from 'services';
import UserServices from 'services/userServices';
import { isResponseSuccess, cloneObjectByKeys, getFileName, isResponseURL } from 'helpers';
import {
  USER_SERVLET_URL,
  MANAGE_USERS_URL,
  ADMIN_SERVLET_URL,
  EXPORT_READFILE_URL,
  DELETE_DID_URL,
} from 'consts/api';
import cloneDeep from 'lodash/cloneDeep';
// import { getManageUser } from "./manageUserSaga";
import { TIME_OUT_CLOSE_TOAST } from 'consts/data';
import { showError } from 'helpers/handleError';
import { notifySuccess } from 'helpers/handleNotification';
import UserModel from 'models/user.model';

const moment = require('moment');
const fileDownload = require('js-file-download');

const { Notification } = hooks;

const {
  REQUEST_API_USERSERVLET,
  REQUEST_API_USERSERVLET_SUCCESS,
  REQUEST_API_USERSERVLET_FAILED,
  REQUEST_GET_LIST_USERS,
  REQUEST_GET_LIST_USERS_FAILED,
  REQUEST_GET_LIST_USERS_SUCCESS,
  REQUEST_DELETE_USERS,
  REQUEST_DELETE_USERS_FAILED,
  REQUEST_DELETE_USERS_SUCCESS,
  REQUEST_CREATE_USERS,
  REQUEST_CREATE_USERS_FAILED,
  REQUEST_CREATE_USERS_SUCCESS,
  REQUEST_ADD_DIDS,
  REQUEST_ADD_DIDS_FAILED,
  REQUEST_ADD_DIDS_SUCCESS,
  REQUEST_MIGRATE_DIDS,
  REQUEST_MIGRATE_DIDS_FAILED,
  REQUEST_MIGRATE_DIDS_SUCCESS,
  REQUEST_SHOW_DIDS,
  REQUEST_SHOW_DIDS_FAILED,
  REQUEST_SHOW_DIDS_SUCCESS,
  REQUEST_DELETE_VIRTUALPHONE,
  REQUEST_DELETE_VIRTUALPHONE_FAILED,
  REQUEST_DELETE_VIRTUALPHONE_SUCCESS,
  REQUEST_ADD_CREDITS_USER,
  REQUEST_ADD_CREDITS_USER_SUCCESS,
  REQUEST_ADD_CREDITS_USER_FAILED,
  REQUEST_UPDATE_USER,
  REQUEST_UPDATE_USER_FAILED,
  REQUEST_UPDATE_USER_SUCCESS,
  REQUEST_CLONE_USER,
  REQUEST_CLONE_USER_SUCCESS,
  REQUEST_CLONE_USER_FAILED,
  REQUEST_UPDATE_PROFILE,
  REQUEST_UPDATE_PROFILE_SUCCESS,
  REQUEST_UPDATE_PROFILE_FAILED,
  REQUEST_UPDATE_SETTING,
  REQUEST_UPDATE_SETTING_SUCCESS,
  REQUEST_UPDATE_SETTING_FAILED,
  REQUEST_UPDATE_SETTING_API,
  REQUEST_UPDATE_SETTING_API_FAILED,
  REQUEST_UPDATE_SETTING_API_SUCCESS,
  REQUEST_BACKUP_NOW,
  REQUEST_BACKUP_NOW_FAILED,
  REQUEST_BACKUP_NOW_SUCCESS,
  REQUEST_RESTORE,
  REQUEST_RESTORE_FAILED,
  REQUEST_RESTORE_SUCCESS,
  REQUEST_EXPORT_USER,
  REQUEST_EXPORT_USER_SUCCESS,
  REQUEST_EXPORT_USER_FAILED,
  REQUEST_EXPORT_CREDIT_STATUS,
  REQUEST_EXPORT_CREDIT_STATUS_FAILED,
  REQUEST_EXPORT_CAMPAIN,
  REQUEST_EXPORT_CAMPAIN_FAILED,
  REQUEST_UPDATE_REQUEST_CLICK,
  REQUEST_UPDATE_REQUEST_CLICK_SUCCESS,
  REQUEST_UPDATE_REQUEST_CLICK_FAILED,
  REQUEST_REFRESH_USER_LIST,

  REQUEST_DELETE_BULK_VIRTUAL_PHONE,
  REQUEST_DELETE_BULK_VIRTUAL_PHONE_SUCCESS,
  REQUEST_DELETE_BULK_VIRTUAL_PHONE_FAILED,
} = types;

export function* getUserServlet() {
  try {
    const response = yield UserServices.getUserInfo();
    if (isResponseSuccess(response.status) && response.data) {
      if (typeof response.data === 'string' && response.data.toLowerCase() === 'fail') {
        yield put({ type: REQUEST_API_USERSERVLET_FAILED, error: 'FAIL' });
      } else {
        yield put({
          type: REQUEST_API_USERSERVLET_SUCCESS,
          payload: {
            ...response.data,
            name: `${response.data.firstname} ${response.data.lastname}`,
          },
        });
      }
    }
  } catch (error) {
    yield put({ type: REQUEST_API_USERSERVLET_FAILED, error });
  }
}

function* getListUsers(data) {
  const {
    sortFields,
    sortDirections,
    pageSize,
    pageIndex,
    searchFilters,
    searchValues,
    userStatuses,
    operator,
  } = data;

  try {
    const filters = {
      sortDirections,
      searchValues,
      searchFilters: searchFilters,
      operator: operator,
      sortFields,
      pageSize,
      page: pageIndex + 1,
      userStatuses: (userStatuses || []).map((el) => el?.status).join(','),
    };
    const res = yield UserServices.getListUser({
      action: 'searchBySelectedField',
      filters,
    });

    if (isResponseSuccess(res.status)) {
      if (res.data?.includes('null')) {
        yield put({
          type: REQUEST_GET_LIST_USERS_SUCCESS,
          data: [],
          total: 0,
        });
        return;
      }
      if (res.data && typeof res.data === 'object') {
        const resTotal = yield UserServices.getTotalListUser({
          action: 'totalBySelectedField',
          filters,
        });
        if (isResponseSuccess(resTotal.status)) {
          yield put({
            type: REQUEST_GET_LIST_USERS_SUCCESS,
            data: res.data,
            total: resTotal.data,
          });
        }
      } else if (typeof res.data === 'string') {
        Notification('error', 'Something wrong! Please report to us!', '', TIME_OUT_CLOSE_TOAST);
        yield put({
          type: REQUEST_GET_LIST_USERS_FAILED,
          error: res.data.toString(),
        });
      }
    }
  } catch (error) {
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_GET_LIST_USERS_FAILED, error });
  }
}

function* deleteUser(data) {
  data.action = 'deleteUsers';
  const { emails, action, setSubmitting, toggle, filters } = data;
  try {
    setSubmitting(true);
    const res = yield UserServices.deleteUser({ action, emails });
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message === 'success') {
          yield getListUsers(filters);
          setSubmitting(false);
          toggle();
          Notification('success', 'Deleted Successfully!', '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_DELETE_USERS_SUCCESS });
        } else {
          setSubmitting(false);
          toggle();
          Notification('error', message, '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_DELETE_USERS_FAILED, error: message });
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    toggle();
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_DELETE_USERS_FAILED, error });
  }
}

function* createUser(data) {
  const { toggle, setSubmitting, filters } = data;
  const dataClone = cloneDeep(data);

  try {
    const res = yield UserServices.createUser({
      action: 'createUser',
      dataUser: UserModel.parseRequestUpdateUser(dataClone),
    });
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data;
        if (message.toLowerCase().includes('success')) {
          // Re-get list
          yield getListUsers(filters);

          setSubmitting(false);
          toggle();
          Notification('success', message, '', TIME_OUT_CLOSE_TOAST);
          yield put({
            type: REQUEST_CREATE_USERS_SUCCESS,
          });
        } else if (message === 'exist') {
          setSubmitting(false);
          Notification(
            'error',
            'This email already exist. Please try again with another email.',
            'EXIST!',
            TIME_OUT_CLOSE_TOAST,
          );
          yield put({ type: REQUEST_CREATE_USERS_FAILED, error: message });
        } else if (message === 'fail_no_agentmail') {
          setSubmitting(false);
          Notification(
            'error',
            'The agent email is not exist. Please try again.',
            'NOT EXIST!',
            TIME_OUT_CLOSE_TOAST,
          );
          yield put({ type: REQUEST_CREATE_USERS_FAILED, error: message });
        } else {
          setSubmitting(false);
          Notification('error', message, '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_CREATE_USERS_FAILED, error: message });
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_CREATE_USERS_FAILED, error });
  }
}

function* updateUser(data) {
  const { isEditItSelf, callbacks, filters } = data;

  try {
    const res = yield UserServices.updateManageUser(
      UserModel.parseRequestUpdateUser(data, { isUpdate: true }),
    );

    if (isResponseSuccess(res.status)) {
      if (res.data['RESPONSE']) {
        if (res.data['RESPONSE'] === 'FAIL') {
          Notification('error', res.data['REASON'], '', TIME_OUT_CLOSE_TOAST);
          yield put({
            type: REQUEST_UPDATE_USER_FAILED,
            error: res.data['REASON'],
          });
          callbacks && callbacks.onFailed(res);
        }
      }

      if (typeof res.data === 'string') {
        const message = res.data;
        if (message.toLowerCase().includes('success')) {
          callbacks && callbacks.onSuccess(res);

          Notification('success', message, '', TIME_OUT_CLOSE_TOAST);
          if (isEditItSelf) {
            yield getUserServlet();
          }
          yield put({ type: REQUEST_UPDATE_USER_SUCCESS });
          yield getListUsers(filters);
        } else {
          Notification('error', message, '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_UPDATE_USER_FAILED, error: message });
          callbacks && callbacks.onFailed(res);
        }
      }
    }
  } catch (error) {
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_UPDATE_USER_FAILED, error });
    callbacks && callbacks.onFailed(error);
  }
}

function* showDids(data) {
  data.action = 'fetchPhoneNumbers';
  const { action, useremail, filters = {} } = data;
  const listDid = yield select((state) => state.userServletReducer.didInUser.listDid);
  try {
    const { offset = 0 } = filters;
    const res = yield UserServices.showDid({
      action,
      useremail,
      offset,
    });

    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'object') {
        yield put({
          type: REQUEST_SHOW_DIDS_SUCCESS,
          data: res.data,
        });
      } else {
        const message = res.data.toLowerCase();
        if (message === 'notexist') {
          if (listDid.length > 0) {
            yield put({
              type: REQUEST_SHOW_DIDS_SUCCESS,
              isLastItem: true,
            });
          } else {
            yield put({
              type: REQUEST_SHOW_DIDS_FAILED,
              error: 'No phone number was found for the selected user !',
            });
          }
        } else {
          Notification('error', message, '', TIME_OUT_CLOSE_TOAST);
          yield put({
            type: REQUEST_SHOW_DIDS_FAILED,
            error: message,
          });
        }
      }
    }
  } catch (error) {
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_SHOW_DIDS_FAILED, error });
  }
}

function* addDids(data) {
  data.action = 'addVirtualPhone';
  const { action, filters, callbacks, body = {} } = data;
  try {
    const res = yield Services.post(
      MANAGE_USERS_URL,
      Querystring.stringify({
        action,
        ...body,
      }),
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        // Re-get show dids
        yield showDids({
          action: 'fetchPhoneNumbers',
          filters,
          useremail: body.emailUser,
        });

        yield put({ type: REQUEST_ADD_DIDS_SUCCESS });
        callbacks && callbacks.onSuccess(res);
      } else {
        callbacks && callbacks.onFailed(res.data);
        Notification('error', res.data.toString(), '', TIME_OUT_CLOSE_TOAST);
        yield put({
          type: REQUEST_ADD_DIDS_FAILED,
          error: res.data.toString(),
        });
      }
    }
  } catch (error) {
    callbacks && callbacks.onFailed(error.toString());
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_ADD_DIDS_FAILED, error });
  }
}

function* migrateDids(data) {
  data.action = 'migrateVirtualPhone';
  const { action, payload = {}, callbacks } = data;
  try {
    const {
      fromEmailUser,
      toEmailUser,
      chargeFee,
      targetDidGroupId,
      sourceDidGroupId,
      numberOfPhone,
      country,
    } = payload;
    const res = yield Services.post(
      MANAGE_USERS_URL,
      Querystring.stringify({
        action,
        fromEmailUser,
        toEmailUser,
        chargeFee,
        targetDidGroupId,
        sourceDidGroupId,
        numberOfPhone,
        country,
      }),
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        if (res.data.toLowerCase().includes('successfully')) {
          callbacks && callbacks.onSuccess(res);
          Notification('success', 'Migrated Successfully!', '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_MIGRATE_DIDS_SUCCESS });
        } else {
          callbacks && callbacks.onFailed(res);
          Notification('error', res.data, '', TIME_OUT_CLOSE_TOAST);
          yield put({
            type: REQUEST_MIGRATE_DIDS_FAILED,
            error: res.data,
          });
        }
      } else {
        callbacks && callbacks.onFailed(res);
        Notification('error', res.data.toString(), '', TIME_OUT_CLOSE_TOAST);
        yield put({
          type: REQUEST_MIGRATE_DIDS_FAILED,
          error: res.data.toString(),
        });
      }
    }
  } catch (error) {
    callbacks && callbacks.onFailed(error);
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_MIGRATE_DIDS_FAILED, error });
  }
}

function* deleteVirtualPhone(data) {
  const { phone, toggle, setSubmitting } = data;
  try {
    setSubmitting(true);
    const res = yield Services.post(DELETE_DID_URL, {
      phone,
    });
    if (isResponseSuccess(res.status)) {
      toggle();
      setSubmitting(false);
      Notification('success', 'Deleted Successfully!', '', TIME_OUT_CLOSE_TOAST);
      yield put({ type: REQUEST_DELETE_VIRTUALPHONE_SUCCESS, phone: phone });
    }
  } catch (error) {
    setSubmitting(false);
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_DELETE_VIRTUALPHONE_FAILED, error });
  }
}

function* deleteBulkVirtualPhone(data) {
  const { listDids, callbacks } = data;
  try {
    const listReq = listDids.map((did) =>
      Services.post(DELETE_DID_URL, {
        phone: did,
      }),
    );

    yield Promise.all(listReq);
    Notification('success', `Deleted ${listDids.length} Successfully!`, '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_DELETE_BULK_VIRTUAL_PHONE_SUCCESS, listDidsRemoved: listDids });
    callbacks.onSuccess();
  } catch (error) {
    callbacks.onFailed(error);
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_DELETE_BULK_VIRTUAL_PHONE_FAILED, error });
  }
}

function* addCredit(data) {
  data.action = 'sendUserBonusTexts';
  const { useremail, _type: type, noOfTexts, setSubmitting, toggle, action, filters } = data;
  try {
    const res = yield UserServices.addCredit({
      action,
      useremail,
      type,
      noOfTexts,
    });
    if (isResponseSuccess(res.status)) {
      if (res.data && typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message === 'success') {
          // Update credit of account which logging in
          yield getListUsers(filters);
          toggle();
          setSubmitting(false);
          Notification('success', 'Added Credit Successfully!', '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_ADD_CREDITS_USER_SUCCESS });
        } else {
          setSubmitting(false);
          Notification('error', message, '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_ADD_CREDITS_USER_FAILED, error: message });
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_ADD_CREDITS_USER_FAILED, error });
  }
}

function* cloneUser(data) {
  data.action = 'cloneUser';
  const { setSubmitting, toggle, filters, action } = data;
  try {
    setSubmitting(true);
    const res = yield UserServices.cloneUser({ dataUser: data, action });
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message === 'success') {
          yield getListUsers(filters);
          setSubmitting(false);
          Notification('success', 'Cloned Successfully!', '', TIME_OUT_CLOSE_TOAST);
          toggle();
          yield put({ type: REQUEST_CLONE_USER_SUCCESS });
        } else if (message === 'exist') {
          setSubmitting(false);
          Notification(
            'error',
            'Email input is existed! Please try again with other email!',
            '',
            TIME_OUT_CLOSE_TOAST,
          );
          yield put({ type: REQUEST_CLONE_USER_FAILED, error: message });
        } else {
          setSubmitting(false);
          Notification('error', message, '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_CLONE_USER_FAILED, error: message });
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_CLONE_USER_FAILED, error });
  }
}

function* updateProfile(data) {
  data.action = 'update';
  const { setSubmitting } = data;
  const dataPost = cloneObjectByKeys(
    [
      'action',
      'myAccountPhone',
      'myAccountFirstname',
      'myAccountLastname',
      'myAccountGender',
      'myAccountAddress1',
      'myAccountAddress2',
      'myAccountCity',
      'myAccountState',
      'myAccountZip',
      'myAccountTxn',
      'myAccountCompany',
      'myAccountCompanyDesc',
      'myAccountCompanyPhone',
      'myAccountIndustry',
      'myAccountNoCustomers',
    ],
    data,
  );
  try {
    const res = yield Services.post(
      USER_SERVLET_URL,
      Querystring.stringify(dataPost),
      HeaderUTF8Option,
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message === 'success') {
          yield getUserServlet();
          Notification('success', 'Updated Successfully!', '', TIME_OUT_CLOSE_TOAST);
          setSubmitting(false);
          yield put({ type: REQUEST_UPDATE_PROFILE_SUCCESS });
        } else {
          setSubmitting(false);
          Notification('error', message, '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_UPDATE_PROFILE_FAILED, error: message });
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_UPDATE_PROFILE_FAILED, error });
  }
}

function* updateSettings(data) {
  data.action = 'updateSettings';
  const { setSubmitting } = data;
  const dataPost = cloneObjectByKeys(
    [
      'action',
      'useAgencyCredit',
      'enableCreditPooling',
      'deleteInboxThreadForOptOuts',
      'chkSleepTimer',
      'startSleepTime',
      'endSleepTime',
      'chkIncomingNoti',
      'chkEmailIncomingNoti',
      'chkEmailSSL',
      'sendMailBy',
      'smtpServerName',
      'smtpFullName',
      'smtpFrom',
      'smtpUserName',
      'smtpServerPass',
      'toEmails',
      'sendEmailHour',
      'chkSMSIncomingNoti',
      'chkDontShowInbox',
      'notifPhone',
      'notifSendBy',
      'chkDailyBk',
      'statsForResponders',
      'sharedOptoutDup',
      'globalAccuracy',
      'myAccountSlackURL',
      'zendeskURL',
      'zendeskUN',
      'zendeskPW',
      'zendeskAll',
      'zendeskCreate',
      'contactTimezone',
      'archiveInboxDay',
      'archiveInboxMsgCount',
      'isArchiveInboxDay',
      'isArchiveInboxMsgCount',
      'prefillOfferConfig',
      'prefillOfferEnable',
      'fullfillOfferEnable',
      'fullfillOfferConfig',

      'balanceNotiEmail',
      'balanceNotiPublish',
      'campaignNotiEmail',
      'campaignNotiPublish',
      'importContactNotiEmail',
      'importContactNotiPublish',
      'priceChangeNotiEmail',
      'priceChangeNotiPublish',
      'scrubNotiEmail',
      'scrubNotiPublish',
      'transactionNotiEmail',
      'transactionNotiPublish',
      'seedNumber',
      'seedEnabled',
      'notiEmailAddress',

      //* TA-601
      'domainNotiPublish',
      'domainNotiEmail',

      'autoOpActive',
      'autoOpLap2Active',
      'autoOpTestSizeLap1',
      'autoOpTestSizeLap2',
      'autoOpThresholdLap1',
      'autoOpThresholdLap2',
      'autoOpPausedMinLap1',
      'autoOpPausedMinLap2',
      'autoOpLap2CreativeSize',

      'ticketUpdateNotiEmail',
      'ticketUpdateNotiPublish',
    ],
    data,
  );

  dataPost.fullfillOfferConfig = dataPost.fullfillOfferConfig.replace('?', '');
  dataPost.notiEmailAddress = (dataPost?.notiEmailAddress || '').trim();

  try {
    const res = yield UserServices.updateSetting(dataPost);
    if (isResponseSuccess(res.status)) {
      const message = res.data.toLowerCase();
      if (message.includes('successfully')) {
        yield getUserServlet();
        Notification('success', 'Updated Successfully!', '', TIME_OUT_CLOSE_TOAST);
        setSubmitting(false);
        yield put({ type: REQUEST_UPDATE_SETTING_SUCCESS });
      } else {
        setSubmitting(false);
        Notification('error', message, '', TIME_OUT_CLOSE_TOAST);
        yield put({ type: REQUEST_UPDATE_SETTING_FAILED, error: message });
      }
    }
  } catch (error) {
    setSubmitting(false);
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_UPDATE_SETTING_FAILED, error });
  }
}

function* updateSettingsAPI(data) {
  data.action = 'updateApiSetting';
  const { setSubmitting } = data;
  const dataPost = cloneObjectByKeys(
    ['action', 'apiPostback', 'globalIncomingUrl', 'globalIncomingMethod', 'checkAPIMode'],
    data,
  );
  try {
    setSubmitting(true);
    const res = yield Services.post(
      USER_SERVLET_URL,
      Querystring.stringify(dataPost),
      HeaderUTF8Option,
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message.includes('successfully')) {
          yield getUserServlet();
          setSubmitting(false);
          Notification('success', 'Updated Successfully', '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_UPDATE_SETTING_API_SUCCESS });
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_UPDATE_SETTING_API_FAILED, error });
  }
}

function* backup(data) {
  data.action = 'updateSettings';
  try {
    const dataPost = cloneObjectByKeys(
      [
        'action',
        'archiveInboxDay',
        'archiveInboxMsgCount',
        'isArchiveInboxDay',
        'isArchiveInboxMsgCount',
      ],
      data,
    );
    const res = yield Services.post(USER_SERVLET_URL, Querystring.stringify(dataPost));
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string' && res.data.includes('successfully')) {
        const backupRes = yield Services.post(
          USER_SERVLET_URL,
          Querystring.stringify({
            action: 'backupNow',
          }),
        );
        if (isResponseSuccess(backupRes.status)) {
          if (typeof backupRes.data === 'string') {
            Notification('success', 'Backed up successfully', '', TIME_OUT_CLOSE_TOAST);
            yield put({ type: REQUEST_BACKUP_NOW_SUCCESS });
          }
        }
      }
    }
  } catch (error) {
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_BACKUP_NOW_FAILED, error });
  }
}

function* restore(data) {
  data.action = 'doRestore';
  const { fileName, isRestoreContact, isRestoreData, isRestoreDelete, action } = data;
  try {
    const res = yield Services.post(
      USER_SERVLET_URL,
      Querystring.stringify({
        action,
        fileName,
        isRestoreContact,
        isRestoreData,
        isRestoreDelete,
      }),
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string' && res.data.toLowerCase().includes('successfully')) {
        yield getUserServlet();
        Notification('success', 'Restored successfully!', '', TIME_OUT_CLOSE_TOAST);
        yield put({ type: REQUEST_RESTORE_SUCCESS });
      } else {
        Notification('error', 'Something went wrong', '', TIME_OUT_CLOSE_TOAST);
        yield put({
          type: REQUEST_RESTORE_FAILED,
          error: 'Something went wrong',
        });
      }
    }
  } catch (error) {
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_RESTORE_FAILED, error });
  }
}

function* checkingExport(successCallback = () => {}, errorCallback = () => {}) {
  try {
    const response = yield Services.post(
      MANAGE_USERS_URL,
      Querystring.stringify({
        action: 'checkExport',
      }),
    );
    if (isResponseSuccess(response.status)) {
      if (typeof response.data === 'string') {
        if (response.data.toLowerCase() === 'running') {
          yield delay(1500);
          yield checkingExport(successCallback, errorCallback);
        } else {
          yield put({ type: REQUEST_EXPORT_USER_SUCCESS });
          if (isResponseURL(response.data)) {
            const getFileCSV = yield Services.get(`${EXPORT_READFILE_URL}?file=${response.data}`);
            if (isResponseSuccess(getFileCSV.status)) {
              if (getFileCSV.data && typeof getFileCSV.data === 'string') {
                const fileName = getFileName(getFileCSV);
                fileDownload(getFileCSV.data, fileName);
                successCallback();
              } else {
                errorCallback();
                Notification(
                  'error',
                  'Something was wrong! Please try again!',
                  '',
                  TIME_OUT_CLOSE_TOAST,
                );
              }
            }
          }
        }
      }
    }
  } catch (error) {
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_EXPORT_USER_FAILED, error });
  }
}

function* exportUser(data) {
  data.action = 'export';
  try {
    const { isSelectAll, exceptUsername, onlyUsernames, action } = data;
    const body = isSelectAll
      ? Querystring.stringify({
          action,
          isSelectAll,
          exceptUsername,
        })
      : Querystring.stringify({
          action,
          isSelectAll,
          exceptUsername,
          onlyUsernames,
        });
    const res = yield Services.post(MANAGE_USERS_URL, body, HeaderUTF8Option);
    if (isResponseSuccess(res.status)) {
      yield checkingExport();
    }
  } catch (error) {
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_EXPORT_USER_FAILED, error });
  }
}

function* exportCreditStatus(data) {
  data.action = 'statsexport';
  const { action, setSubmitting, fromDate, toDate, onlyUsernames, exceptUsername } = data;
  try {
    setSubmitting(true);
    const res = yield Services.post(
      MANAGE_USERS_URL,
      Querystring.stringify({
        action,
        fromDate: moment(fromDate).format('MM/DD/YYYY'),
        toDate: moment(toDate).format('MM/DD/YYYY'),
        exceptUsername,
        onlyUsernames,
      }),
      HeaderUTF8Option,
    );

    if (isResponseSuccess(res.status)) {
      if (res.status) {
        if (typeof res.data === 'string') {
          if (res.data === 'FAIL') {
            setSubmitting(false);
            Notification('error', res.data, 'Error', TIME_OUT_CLOSE_TOAST);
            yield put({
              type: REQUEST_EXPORT_CREDIT_STATUS_FAILED,
              error: res.data,
            });
          } else {
            // TODO: DO AFTER CLOUDTEXTBACK AI RUN
          }
        }
      }
    }
  } catch (error) {
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_EXPORT_CREDIT_STATUS_FAILED, error });
  }
}

function* exportCampaignStats(data) {
  data.action = 'campaignexport';
  const { action, exceptUsername, onlyUsernames, lastSentDate, setSubmitting, toggle } = data;
  try {
    const res = yield Services.post(
      ADMIN_SERVLET_URL,
      Querystring.stringify({
        action,
        exceptUsername,
        onlyUsernames,
        lastSentDate: moment(lastSentDate).format('MM/DD/YYYY'),
      }),
      HeaderUTF8Option,
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        if (res.data.includes('successfully')) {
          yield checkingExport(() => {
            setSubmitting(false);
            toggle();
          });
        } else {
          setSubmitting(false);
          Notification('info', res.data, '', TIME_OUT_CLOSE_TOAST);
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_EXPORT_CAMPAIN_FAILED, error });
  }
}

function* regenerateAPIKey(data) {
  const { useremail, callbacks } = data;
  try {
    const response = yield UserServices.regenerateApiKey(useremail);
    const userResponse = response?.data;
    yield put({
      type: types.REQUEST_REGENERATE_API_KEY_SUCCESS,
      payload: { userResponse, email: useremail },
    });
    notifySuccess('Regenertate API Key successfully!', 'Success');
    callbacks && callbacks.onSuccess();
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_REGENERATE_API_KEY_FAILED, error });
  }
}

function* updateRequestClick(data) {
  const { setSubmitting, resetForm } = data;
  const dataPost = cloneObjectByKeys(
    ['skipUserAgentList', 'enableSkipUserAgent', 'skipIpList', 'enableSkipIp'],
    data,
  );
  try {
    setSubmitting(true);
    const res = yield UserServices.updateClickFilter(dataPost);
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message.includes('successfully')) {
          yield getUserServlet();
          setSubmitting(false);
          resetForm();
          Notification('success', 'Updated Successfully', '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_UPDATE_REQUEST_CLICK_SUCCESS });
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    Notification('error', error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_UPDATE_REQUEST_CLICK_FAILED, error });
  }
}

function* refreshUserList(data) {
  const { filters } = data;
  try {
    yield getListUsers(filters);
  } catch (error) {
    showError(error);
  }
}

function* saveLayoutMonitoring(data) {
  const { nextColumns, callbacks } = data;
  try {
    yield UserServices.changeLayoutMonitoring(nextColumns);
    yield put({ type: types.REQUEST_SAVE_LAYOUT_MONITORING_SUCCESS, nextColumns });
    callbacks && callbacks.onSuccess();
  } catch (error) {
    yield put({ type: types.REQUEST_SAVE_LAYOUT_MONITORING_FAILED, error });
    callbacks && callbacks.onFailed(error);
  }
}

export default function* watchGetAPIFunction() {
  yield takeEvery(REQUEST_API_USERSERVLET, getUserServlet);
  yield takeLatest(REQUEST_GET_LIST_USERS, getListUsers);
  yield takeLatest(REQUEST_DELETE_USERS, deleteUser);
  yield takeLatest(REQUEST_CREATE_USERS, createUser);
  yield takeLatest(REQUEST_SHOW_DIDS, showDids);
  yield takeLatest(REQUEST_ADD_DIDS, addDids);
  yield takeLatest(REQUEST_MIGRATE_DIDS, migrateDids);
  yield takeLatest(REQUEST_DELETE_VIRTUALPHONE, deleteVirtualPhone);
  yield takeLatest(REQUEST_DELETE_BULK_VIRTUAL_PHONE, deleteBulkVirtualPhone);
  yield takeLatest(REQUEST_ADD_CREDITS_USER, addCredit);
  yield takeLatest(REQUEST_UPDATE_USER, updateUser);
  yield takeLatest(REQUEST_CLONE_USER, cloneUser);
  yield takeLatest(REQUEST_UPDATE_PROFILE, updateProfile);
  yield takeLatest(REQUEST_UPDATE_SETTING, updateSettings);
  yield takeLatest(REQUEST_UPDATE_SETTING_API, updateSettingsAPI);
  yield takeLatest(REQUEST_UPDATE_REQUEST_CLICK, updateRequestClick);
  yield takeLatest(REQUEST_BACKUP_NOW, backup);
  yield takeLatest(REQUEST_RESTORE, restore);
  yield takeLatest(REQUEST_EXPORT_USER, exportUser);
  yield takeLatest(REQUEST_EXPORT_CREDIT_STATUS, exportCreditStatus);
  yield takeLatest(REQUEST_EXPORT_CAMPAIN, exportCampaignStats);
  yield takeLatest(types.REQUEST_REGENERATE_API_KEY, regenerateAPIKey);
  yield takeLatest(REQUEST_REFRESH_USER_LIST, refreshUserList);

  yield takeLatest(types.REQUEST_SAVE_LAYOUT_MONITORING, saveLayoutMonitoring);

  // Update switch user box
  // yield takeLatest(REQUEST_CREATE_USERS_SUCCESS, getManageUser);
  // yield takeLatest(REQUEST_DELETE_USERS_SUCCESS, getManageUser);
  // yield takeLatest(REQUEST_CLONE_USER_SUCCESS, getManageUser);
}
